import React from 'react';
import { Box, Typography } from '@mui/material';
import { CustomButton } from '../../../v2/MUI_custom_component';
import IllustrationWrapper from '../../Illustrration/IllustrationWrapper';
import NoInventorySvg from '../../Illustrration/components/NoInventorySvg';
import DisplaySelectedRole from './DisplaySelectedRole';

const ConfirmSelectedRolesSection = ({
  selectedManufacturerRoles = [],
  onDelete,
  onEditOrAdd,
}) => {
  const hasSelectedRoles = selectedManufacturerRoles.length > 0;

  return (
    <Box
      sx={{
        background: '#fff',
        borderRadius: 2,
        p: 2,
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant="labelD">Manufacturers & Roles</Typography>
      </Box>

      {hasSelectedRoles ? (
        selectedManufacturerRoles.map((role, index) => (
          <DisplaySelectedRole
            key={`${role.manufacturer_id}-${index}`}
            role={role}
            onDelete={onDelete}
          />
        ))
      ) : (
        <Box>
          <IllustrationWrapper
            titleVariant="h3"
            subtitleVariant="body1"
            subtitleStyle={{ color: '#666' }}
            illustration={<NoInventorySvg />}
            illustrationProps={{
              width: 160,
              height: 132,
            }}
          />
        </Box>
      )}

      <CustomButton
        label={hasSelectedRoles ? 'Edit or Add Manufacturer' : 'Add Manufacturer'}
        variant="text"
        fullWidth
        onClick={onEditOrAdd}
      />
    </Box>
  );
};

export default ConfirmSelectedRolesSection;
